import { Directive, ElementRef, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appTabHeading]',
    standalone: false
})
export class TabHeadingDirective {
  constructor(readonly templateRef: TemplateRef<ElementRef<HTMLElement>>) {}
}
